/* eslint-disable max-lines */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_visitSettlement: {
         adjustmentModal: {
            commands: {
               adjust: {
                  errors: {
                     unexpectedError:
                        'Nie udało się zapisać korekty dla wizyty. Usługa MUP jest w tej chwili niedostępna.',
                  },
                  successfully: 'Korekta rozliczenia została zapisana.',
               },
            },
            title: 'Korekta rozliczenia',
         },
         counterResolver: {
            errors: {
               unexpectedError: 'Usługa MUP jest w tej chwili niedostępna.',
            },
         },
         extensions: {
            appointments: {
               dropdownOption: {
                  adjustment: {
                     label: 'Korekta rozliczenia',
                  },
                  errors: {
                     unexpectedError: 'Usługa MUP jest w tej chwili niedostępna.',
                  },
                  payment: {
                     label: 'Rozliczenie',
                  },
               },
            },
            calendar: {
               tab: {
                  confirmButton: {
                     adjustment: 'Korekta rozliczenia',
                     payment: 'Rozlicz',
                  },
                  content: {
                     adjustmentNote: 'Notatka do korekty',
                     advancePaymentMethodTextView: '(przedpłata), {{advancePaymentMethod}}',
                     noPriceChangeReason: 'Brak uzasadnienia',
                     payment: 'Kwota opłacona',
                     paymentMethodDescription: '{{method}} ({{description}})',
                     paymentMethodMap: {
                        BANK_TRANSFER: 'przelew',
                        CASH: 'gotówka',
                        ONLINE_PAYMENT: 'płatność online',
                        OTHER: 'inna',
                        PAYMENT_CARD: 'karta płatnicza',
                     },
                     priceChangeReason: 'Zmiana ceny',
                  },
                  createInvoiceButton: 'Wystaw fakturę',
                  downloadInvoiceButton: 'Pobierz fakturę',
                  error: 'Funkcja chwilowo niedostępna, spróbuj później.',
                  label: 'Rozliczenie',
               },
            },
            visitForm: {
               formTab: {
                  errors: {
                     couldNotFetchMedicalServices: 'Nie udało się pobrać listy usług',
                     unexpectedError: 'Usługa MUP jest w tej chwili niedostępna.',
                  },
               },
               formTabLabel: 'Usługi ({{count}})',
               payment: {
                  action: {
                     label: 'Rozlicz',
                  },
               },
               priceChangeReason: {
                  action: {
                     tooltip: {
                        edit: 'Edytuj powód zmiany ceny',
                        plus: 'Podaj powód zmiany ceny',
                     },
                  },
                  commands: {
                     update: {
                        errors: {
                           unexpectedError: 'Nie udało się rozliczyć wizyty. Usługa MUP jest w tej chwili niedostępna.',
                           visitAlreadySettledFault: 'Wizyta została już wcześniej rozliczona.',
                        },
                        successfully: 'Powód zmiany ceny został zapisany.',
                     },
                  },
                  modal: {
                     saveAction: {
                        label: 'Zapisz',
                     },
                     title: 'Zmiana ceny',
                  },
               },
            },
            visitHistory: {
               medicalServicesTab: {
                  errors: {
                     fetch: 'Wystąpił błąd pobierania danych na potrzeby wyświetlenia historii.',
                  },
                  label: 'Usługi',
                  medicalServiceName: 'Nazwa usługi',
                  medicalServicePrice: 'Cena',
                  noMedicalServices: 'Brak usług rozliczeniowych',
                  noMedicalServicesSpecified: 'Na wybranej wizycie nie określono żadnych usług rozliczeniowych.',
               },
            },
         },
         paymentModal: {
            commands: {
               updateMedicalServices: {
                  errors: {
                     invalidMedicalServices: 'Popraw usługi rozliczeniowe przed ich rozliczeniem.',
                     unexpectedError: {
                        blockingOperation:
                           'Nie udało się zapisać usług rozliczeniowych. Usługa MUP jest w tej chwili niedostępna.',
                        noBlockingOperation:
                           'Nie udało się zapisać usług rozliczeniowych. Spróbuj ponownie w opcjach wizyty.',
                     },
                     visitAlreadySettledFault: 'Wizyta została już wcześniej rozliczona.',
                  },
                  successfully: 'Zmiany zostały zapisane.',
               },
               updatePayment: {
                  errors: {
                     unexpectedError: 'Nie udało się rozliczyć wizyty. Usługa MUP jest w tej chwili niedostępna.',
                     visitAlreadySettledFault: 'Wizyta została już wcześniej rozliczona.',
                  },
                  successfully: 'Wizyta została rozliczona.',
               },
            },
            confirm: {
               confirm: 'Zatwierdź',
               confirmAndCreateInvoice: 'Zatwierdź i wystaw fakturę',
               save: 'Zapisz',
               saveAndSettle: 'Zapisz i rozlicz',
               settleAndCreateInvoice: 'Rozlicz i wystaw fakturę',
            },
            title: {
               settlement: 'Rozliczenie',
               settlementSummary: 'Podsumowanie rozliczenia',
            },
         },
         shared: {
            adjustment: {
               dataText: {
                  label: 'Skorygowane {{date}} o {{time}} przez:\u00A0{{author}}',
               },
            },
            commands: {
               receiptCreateCommand: {
                  apiTokenFault: 'Problem z połączeniem z Fakturownią. Skontaktuj się ze Wsparciem Technicznym.',
                  externalSystemBusinessFault:
                     'Nie udało się utworzyć faktury. Komunikat z systemu Fakturownia: {{messageFromFakturownia}}',
               },
            },
            form: {
               adjustment: {
                  noteField: {
                     label: 'Notatka do korekty',
                     placeholder: 'Uzupełnij notatkę do korekty...',
                  },
                  previousNote: {
                     label: 'Poprzednia korekta',
                  },
               },
               payment: {
                  acceptedCorrectlyCheckbox: {
                     label: 'Wizyta jest rozliczona prawidłowo',
                  },
                  amountAccepted: {
                     label: 'Kwota przyjęta',
                  },
                  amountInput: {
                     label: 'Kwota opłacona',
                  },
                  methodDescriptionInput: {
                     placeholder: 'Uzupełnij metodę płatności...',
                  },
                  methodRadioGroup: {
                     label: 'Metoda płatności',
                     map: {
                        bankTransfer: 'Przelew',
                        cash: 'Gotówka',
                        other: 'Inna',
                        paymentCard: 'Karta płatnicza',
                     },
                  },
               },
               priceChangeReason: {
                  textView: {
                     label: 'Zmiana ceny',
                     placeholder: 'Brak uzasadnienia',
                  },
               },
               sections: {
                  advancePayment: {
                     actions: {
                        label: 'Zwróć przedpłatę',
                     },
                     header: 'Przedpłata',
                     methodMap: {
                        BANK_TRANSFER: 'przelew',
                        CASH: 'gotówka',
                        ONLINE_PAYMENT: 'płatność online',
                        OTHER: 'inna',
                        PAYMENT_CARD: 'karta płatnicza',
                     },
                  },
                  payment: {
                     header: 'Rozliczenie wizyty',
                  },
                  visitSettlement: {
                     medicalServices: {
                        header: 'Usługi rozliczeniowe',
                     },
                     priceChangeReason: {
                        header: 'Zmiana ceny',
                     },
                  },
               },
               taxIdentifierForReceipt: {
                  label: 'Paragon z NIP',
                  placeholder: 'Uzupełnij NIP...',
               },
               visitDetails: {
                  practitionerTextView: {
                     label: 'Specjalista',
                     noSpecialties: 'brak specjalizacji',
                  },
               },
            },
            medicalServices: {
               advancePayment: {
                  label: 'Przedpłata',
               },
               amountDue: {
                  label: 'Do zapłaty',
               },
               list: {
                  heading: 'Usługi rozliczeniowe',
                  placeholder: 'nie wybrano',
               },
               overpaymentAmount: {
                  label: 'Nadpłata',
               },
               refundAdvancePayment: {
                  label: 'Zwróć przedpłatę',
               },
               selector: {
                  noResultsMessage: 'Brak pasujących usług rozliczeniowych',
                  placeholder: 'Uzupełnij nazwę usługi...',
               },
               table: {
                  headers: {
                     name: 'Nazwa usługi',
                     price: 'Cena',
                  },
                  placeholder: {
                     editable: {
                        heading: 'Nie wybrano żadnej usługi',
                        subheading: 'Uzupełnij usługę rozliczeniową w wyszukiwarce i wybierz jedną z podpowiedzi.',
                     },
                     noEditable: {
                        heading: 'Wizyta została rozliczona',
                        subheading:
                           'Nie możesz edytować rozliczonych usług. Skontaktuj się z kierownikiem, aby wprowadzić zmiany.',
                     },
                  },
               },
               totalPrice: {
                  label: 'Suma',
               },
               updateInterceptor: {
                  errors: {
                     invalidMedicalServices: 'Popraw usługi rozliczeniowe.',
                     unexpectedError: {
                        blockingOperation:
                           'Nie udało się zapisać usług rozliczeniowych. Usługa MUP jest w tej chwili niedostępna.',
                        noBlockingOperation:
                           'Nie udało się zapisać usług rozliczeniowych. Spróbuj ponownie w opcjach wizyty.',
                     },
                     visitAlreadySettledFault: 'Wizyta została już wcześniej rozliczona.',
                  },
                  successfully: 'Zmiany zostały zapisane.',
               },
            },
            priceChangeReason: {
               field: {
                  label: 'Powód',
                  placeholder: 'Podaj powód zmiany ceny usług...',
               },
            },
            totalPrice: {
               label: 'Suma',
            },
         },
      },
   },
};

export const visitSettlementTranslationKeys = createScopedTranslationKeys(translations.pl, 'visit_visitSettlement');
